/* eslint-disable */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppRoutes } from './routes';

function ResetInitializer(props) {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        let token = searchParams.get('token');
        if (searchParams.get('token')) {
            navigate(AppRoutes.resetpassword, { state: { token, isInvite: false } })
        } else {
            navigate('/');
        }
    });

    return (
        <div></div>
    );
}

export default ResetInitializer;